import { render, staticRenderFns } from "./AlertaMensaje.vue?vue&type=template&id=529aa3d9&scoped=true"
import script from "./AlertaMensaje.vue?vue&type=script&lang=js"
export * from "./AlertaMensaje.vue?vue&type=script&lang=js"
import style0 from "./AlertaMensaje.vue?vue&type=style&index=0&id=529aa3d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529aa3d9",
  null
  
)

export default component.exports